import axios from "axios";

// fatch the evalution api
export const fetchEvaluation = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${import.meta.env.VITE_API_BASE_URL}/api/admin/academies`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Failed to fetch evaluation", err.response?.data || err.message);
    throw err; 
  }
};


export const fetchCourses = async () => {
  try {
    const res = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/courses`);
    return res.data; // adjust if response structure is different
  } catch (error) {
    console.error("❌ Failed to load Courses:", error);
    throw error;
  }
};
